import('./app/bootstrap').then(({ bootstrap }) => bootstrap());
